import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { FlatRectRecord } from "../../helper/FlatRectRecord";
import { ItemDisplayRecord } from "../shared/ItemDisplayRecord";
import { ItemTypeDisplayValues } from "../shared/ItemTypeDisplayValues";

export const MindmapNodeDisplayRecord = Record({
  id: null,
  itemId: null,
  itemDisplay: ItemDisplayRecord(),
  typeData: ItemTypeDisplayValues(),
  rect: FlatRectRecord(),
  // Display extensions
  nodeType: null
  // entityValues: EntityDisplayValues()
});

const data = {
  objects: {
    typeData: "ItemTypeDisplayValues",
    itemDisplay: "ItemDisplayRecord",
    rect: "FlatRectRecord"
  }
};
createFromJS.registerCallback(
  "MindmapNodeDisplayRecord",
  createFromJS.createNestedCallback(MindmapNodeDisplayRecord, data)
);
